// src/components/ProtectedRouteWithLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import PortalLayout from "./PortalLayout";

const ProtectedRouteWithLayout = () => {
  return (
    <AuthGuard>
      <PortalLayout>
        <Outlet />
      </PortalLayout>
    </AuthGuard>
  );
};

export default ProtectedRouteWithLayout;
